<ng-container *ngIf="display == 'days'">
  <div>
    <i class="fa fa-chevron-left" (click)="move(-1)" [ngClass]="{'opacity-50': !movable(-1)}"></i>
    <span>Tháng {{month | date : 'MM'}} năm {{month | date : 'yyyy'}}</span>
    <i class="fa fa-chevron-right" (click)="move(1)" [ngClass]="{'opacity-50': !movable(1)}"></i>
  </div>
  <table>
    <tr>
      <th *ngFor="let day of ['T2','T3','T4','T5','T6','T7','CN']">{{day}}</th>
    </tr>
    <tr *ngFor="let y of [0,1,2,3,4,5]">
      <td *ngFor="let x of [0,1,2,3,4,5,6]" [ngClass]="{'opacity-50' : out(x + y * 7)}">
        <span [ngClass]="{'active': active(x + y * 7), 'text-info': today(x + y * 7)}" (click)="select(x + y * 7)">{{day(x + y * 7) | number : '2.0-0' : 'en-US'}}</span>
      </td>
    </tr>
  </table>
</ng-container>

<ng-container *ngIf="display == 'months'">
  <div>
    <i class="fa fa-chevron-left" (click)="move(-12)" [ngClass]="{'opacity-50': !movable(-12)}"></i>
    <span>Năm {{month | date : 'yyyy'}}</span>
    <i class="fa fa-chevron-right" (click)="move(12)" [ngClass]="{'opacity-50': !movable(12)}"></i>
  </div>
  <table>
    <tr *ngFor="let y of [0,1]">
      <td *ngFor="let x of [0,1,2,3,4,5]" [ngClass]="{'opacity-50' : out(x + y * 6)}">
        <span [ngClass]="{'active': active(x + y * 6), 'text-info': thisMonth(x + y * 6)}" (click)="select(x + y * 6)">T{{x + y * 6 + 1 | number : '2.0-0' : 'en-US'}}</span>
      </td>
    </tr>
  </table>
</ng-container>
